export default {
    // 存储策略查询
    getStoragePolicy(params, response) {
        window.vue.$apiAxios.postRequestBody('/storagePolicy/getStoragePolicy', params, response);
    },
    // 获取报警类型下拉树
    getAllStoragePolicy(params, response) {
        window.vue.$apiAxios.get('/storagePolicy/getAllStorageSettings', params, response);
    },
    // 存储策略保存
    saveStoragePolicy(params, response) {
        window.vue.$apiAxios.postRequestBody('/storagePolicy/updateStorageSettings', params, response);
    }
};
